import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import './feedback.scss';

const ICONS = {
  success: 'bi-check-circle-fill',
  danger: 'bi-exclamation-triangle-fill',
  info: 'bi-info-circle-fill',
};

const FeedbackNotice = ({ message, variant, duration, onDismiss }) => {
  useEffect(() => {
    if (!message || !duration) return undefined;
    const timer = window.setTimeout(onDismiss, duration);
    return () => window.clearTimeout(timer);
  }, [duration, message, onDismiss]);

  if (!message || typeof document === 'undefined') return null;

  return createPortal(
    <div className={`feedback-notice feedback-notice-${variant}`} role={variant === 'danger' ? 'alert' : 'status'} aria-live="polite">
      <i className={`bi ${ICONS[variant] || ICONS.info}`} aria-hidden="true"></i>
      <span>{message}</span>
      <button className="btn btn-sm feedback-notice-close" type="button" onClick={onDismiss} aria-label="Dismiss message">
        <i className="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>,
    document.body
  );
};

FeedbackNotice.propTypes = {
  message: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'danger', 'info']),
  duration: PropTypes.number,
  onDismiss: PropTypes.func.isRequired,
};

FeedbackNotice.defaultProps = {
  message: '',
  variant: 'info',
  duration: 5000,
};

export default FeedbackNotice;
